export default __webpack_public_path__ + "static/media/ri_menu-fill.1dffcce8.svg";